export default __webpack_public_path__ + "static/media/kmp-deco-min.86c66575.jpg";